import { useMemo, useRef } from 'react';
import styled from 'styled-components';
import { Banner } from '@elfsight/widget-banner/widget';
import { useSettings } from '@wu/widget-core';

const VERTICALLY_CENTERED_POSITIONS = ['top', 'center', 'bottom'];

export const SlideBuilder = ({
  data,
  googleAnalyticsExtraParameters,
  onSlideLinkClick,
  active,
  isMobile,
  paginationHeight,
  navigationElementsVisibility,
  width
}) => {
  const {
    elements,
    slideLink,
    contentAlignment,
    background,
    padding,
    spacing,
    mobilePadding,
    mobileSpacing
  } = data;

  const {
    googleAnalytics,
    arrowsPosition,
    height,
    mobileHeight,
    editMode,
    widgetToken,
    widgetId,
    stretchBackground
  } = useSettings();

  const bannerRef = useRef(null);

  const [derivedHeight, derivedPadding, derivedSpacing] = useMemo(
    () =>
      isMobile
        ? [mobileHeight, mobilePadding, mobileSpacing]
        : [height, padding, spacing],
    [
      isMobile,
      height,
      mobileHeight,
      padding,
      spacing,
      mobilePadding,
      mobileSpacing
    ]
  );

  const bottomPadding = Math.max(derivedPadding, paginationHeight);

  const isContentVerticallyCentered = VERTICALLY_CENTERED_POSITIONS.includes(
    contentAlignment?.position
  );

  const finalTopPadding = isContentVerticallyCentered
    ? bottomPadding
    : derivedPadding;

  const { arrows, pagination } = navigationElementsVisibility;

  const verticalPadding = [
    pagination ? finalTopPadding : derivedPadding,
    pagination || (arrows && arrowsPosition.startsWith('bottom'))
      ? bottomPadding
      : derivedPadding
  ];

  if (editMode && !elements.length) {
    return <Empty>Add at least 1 block to display Slide</Empty>;
  }

  return (
    <Banner
      googleAnalytics={googleAnalytics}
      googleAnalyticsExtraParameters={googleAnalyticsExtraParameters}
      contentRef={bannerRef}
      blocks={elements}
      bannerLink={slideLink}
      onBannerLinkClick={onSlideLinkClick}
      contentAlignment={contentAlignment}
      bannerBackground={background}
      triggerBackgroundImageAnimationEffect={active}
      verticalBannerHeight={derivedHeight}
      contentPadding={derivedPadding}
      contentSpacing={derivedSpacing}
      contentVerticalPadding={verticalPadding}
      editMode={editMode}
      widgetToken={widgetToken}
      widgetId={widgetId}
      submitAdditionalData={{ type: 'slider' }}
      adaptiveMedia={derivedHeight?.auto}
      stretchBackground={stretchBackground}
      bannerWidth={width}
      style={{ flexBasis: '100%', maxWidth: '100%', marginInline: '0' }}
    />
  );
};

const Empty = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  text-align: center;
`;
